import { RouteRecordRaw } from "vue-router";
import { AuthGuardService } from "@/_guard/AuthGuardService";

const auth = new AuthGuardService();

export const HomeRoutes: RouteRecordRaw[] = [
    {
        path: '/settings',
        name: 'viewHomeSettings',
        meta: { title: 'Settings' },
        component: () => import('@/modules/home/views/viewHomeSettings.vue'),
        beforeEnter: auth.guard,
    },
];